import {Vue, Component} from 'vue-property-decorator';

import {GetPaymentsRequest, GetOrdersByOrderNoRequest} from 'supporter';
import { ValueNameType } from '@/store/modules/orderEnums';
import { namespace } from 'vuex-class';

const orderEnumsModule = namespace('orderEnums');

@Component
export default class ManualConfirm extends Vue {
  @orderEnumsModule.Getter('payTypeMap')
  private readonly payTypeMap!: ValueNameType[];

  public isSuccess: boolean = false;
  public message: any = '';
  public messageEn: any = '';
  public theOrderNo: any = '';
  public shippingsContent: any = [];
  public paymentContent: any = [];
  public thePayType: any = '';

  public checkSucessOrNot(): void {
    if (this.$route.query.result === 'FAIL') {
      this.isSuccess = false;
    } else {
      this.isSuccess = true;
      this.getInfo();
    }
  }

  public getInfo(): void {
    let addressRequest: GetOrdersByOrderNoRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrdersByOrderNo(addressRequest).then((res): any => {
      this.shippingsContent = [];
      this.shippingsContent = res.data.shippings;
    });
    let paymentRequest: GetPaymentsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getPayments(paymentRequest).then((res): any => {
      this.paymentContent = [];
      this.paymentContent = [...res.data];
      this.formatterPaymentContent(this.paymentContent);
    });
  }
  public formatterPaymentContent(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      let flag: any = item.paymentInfo && item.paymentInfo.bankInfo;
      let name: any = flag ? item.paymentInfo.bankInfo.bankName : '';
      this.$set(item, 'theBankName', name);
      this.$set(item, 'theDepositorName', flag ? item.paymentInfo.bankInfo.depositorName : '');
      this.$set(item, 'theAccount', flag ? item.paymentInfo.bankInfo.account : '');
    });
  }
  public getMessage(): void {
    this.message = this.$route.query.message;
    this.messageEn = this.$route.query.message_enc;
    this.theOrderNo = this.$route.query.orderNo;
    this.getPayTypeName(this.$route.query.PayType);
  }
  public goToManualOrder(): void {
    this.$router.push('/order/manual-order');
  }
  public goToOrderDetail(): void {
    this.$router.push(`/order/detail?orderNo=${this.theOrderNo}`);
  }
  public getPayTypeName(type: any): any {
    this.payTypeMap.map((item: any): any => {
      if (item.value === type) {
        this.thePayType = item.name;
      }
    });
  }
}
